import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { getLegislativeBodiesConfig } from 'src/app/pages/petitionGamma/details/shared/api';

export async function isUserEligibleForLegislativeBodies(
	utilityContext: UtilityContext,
	{
		currentUserId,
		currentUserUuid,
		hasShowLegislativeBodiesParam,
	}: {
		currentUserId: string | undefined;
		currentUserUuid: string | undefined;
		hasShowLegislativeBodiesParam: boolean;
	},
): Promise<boolean> {
	if (hasShowLegislativeBodiesParam) return true;

	const legislativeBodiesEnabled = await getLegislativeBodiesConfig(utilityContext);
	if (!legislativeBodiesEnabled) return false;

	if (!currentUserUuid && !currentUserId) return false;

	const userOrSessionId = currentUserId ?? parseInt(currentUserUuid?.at(-1) ?? '0', 16);
	return Number(userOrSessionId) % 2 === 0;
}
